export default __webpack_public_path__ + "static/media/delete-red-icon.ef1465c6.svg";